// src/app/pages/process-folio/process-folio.component.ts
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// import { DigitalProcessResponse } from 'src/app/models/apis/digital-process.model';

import { FullSizeLoadingService } from 'src/app/services/utils/full-size-loading.service';
// import { GoFirstStep, GoToPreviousStep } from 'src/app/models/utils/steps';
import { OnboardingProcessFlowService } from 'src/app/services/onboarding-process-flow.service';
import { AnalyticalLogsService } from 'src/app/services/utils/analytical-logs.service';
import { Store } from '@ngrx/store';
import { PreApplicationActions } from 'src/app/state/actions/pre-application.actions';
import { clearOfferState } from 'src/app/state/actions/preauthorized-offer.actions';

@Component({
	selector: 'app-process-folio',
	templateUrl: './process-folio.component.html',
	styleUrls: ['./process-folio.component.scss'],
})
export class ProcessFolioComponent implements OnInit {
	loading = true;
	error: string | null = null;
	modalContainer: string = '#cmvloadingmodal';

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private onboardingProcessFlowService: OnboardingProcessFlowService,
		private fullSizeLoadingService: FullSizeLoadingService,
		private analyticalLogService: AnalyticalLogsService,
		private store: Store
	) {}

	ngOnInit(): void {
		const productCode = this.route.snapshot.paramMap.get('id');
		const memberNumberParam = this.route.snapshot.queryParamMap.get('num');
		const parsedMemberNumber = Number(memberNumberParam);
		const memberNumber = memberNumberParam
			? Number.isNaN(parsedMemberNumber)
				? undefined
				: parsedMemberNumber
			: undefined;
		const loadingMessage = memberNumberParam
			? 'Cargando oferta preautorizada...'
			: 'Cargando producto de crédito...';
		this.fullSizeLoadingService.open(loadingMessage);
		if (!productCode) {
			this.navigateToHome();
			return;
		}
		const normalizedProductCode = productCode.toUpperCase();
		this.store.dispatch(
			PreApplicationActions.addProductCobisId({
				productCobisId: normalizedProductCode,
			})
		);
		if (typeof memberNumber !== 'number') {
			this.store.dispatch(clearOfferState());
		}
		this.updateOnboardingProcessAndNavigate(normalizedProductCode, memberNumber);
	}

	private updateOnboardingProcessAndNavigate(
		productCode: string,
		memberNumber?: number
	) {
		this.analyticalLogService.logAnalytics({
			notas: 'Carga de codigoProducto',
			paso_proceso: 0,
			titulo_pantalla: 'Cargando oferta preautorizada',
		});
		this.onboardingProcessFlowService
			.loadOnboardingProgressFromOffer(productCode, memberNumber)
			.subscribe({
				next: () => {
					this.fullSizeLoadingService.close();
					console.log(
						'🚀 ~ file: process-folio.component.ts:69 ~ updateOnboardingProcessAndNavigate ~ digitalProcess:'
					);
					this.store.dispatch(
						PreApplicationActions.addProductCobisId({
							productCobisId: productCode,
						})
					);
					this.onboardingProcessFlowService.goFirtsStep();
				},
				error: (error: Error) => {
					this.fullSizeLoadingService.close();
					console.log(
						'🚀 ~ file: process-folio.component.ts:73 ~ updateOnboardingProcessAndNavigate ~ error:',
						error
					);
					this.analyticalLogService.logAnalytics({
						exception_error: error.message,
					});
					this.navigateToHome();
				},
				complete: () => {
					this.fullSizeLoadingService.close();
				},
			});
	}

	private navigateToHome() {
		this.router.navigate(['/sites/home'], { skipLocationChange: true });
	}
}
